// Compteurs sociaux déterministes — synchronisés sur tous les visiteurs.
//
// La valeur affichée :
//   - reste IDENTIQUE pour tous les utilisateurs pendant la période active
//   - change AUTOMATIQUEMENT au passage du seuil (sans cron backend) :
//       • weeklyCounter   → change tous les dimanches à minuit (= lundi 00:00)
//       • monthlyCounter  → change le 1er de chaque mois à 5h du matin
//       • dailyCounter    → change tous les jours à minuit
//
// Aucun appel backend, aucune dépendance. La période courante sert de seed
// à un PRNG déterministe (mulberry32) qui pioche une valeur dans [min, max].

function hashStr(s) {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

function mulberry32(seed) {
  let t = seed >>> 0;
  return function () {
    t = (t + 0x6D2B79F5) >>> 0;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}

function pickInRange(seedStr, min, max) {
  const rng = mulberry32(hashStr(seedStr));
  return Math.floor(min + rng() * (max - min + 1));
}

// ISO week (lundi = jour 1) — utilisé pour les compteurs hebdomadaires.
// Le compteur change au passage de lundi 00:00 (= dimanche minuit).
function isoYearWeek(d = new Date()) {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = t.getUTCDay() || 7;
  t.setUTCDate(t.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((t - yearStart) / 86400000 + 1) / 7);
  return { year: t.getUTCFullYear(), week };
}

/**
 * Compteur hebdomadaire (change tous les dimanches à minuit).
 * @param {string} seedStr   identifiant unique du compteur (ex: 'quiz-hub-weekly')
 * @param {number} min       valeur minimale possible
 * @param {number} max       valeur maximale possible (inclusive)
 */
export function weeklyCounter(seedStr, min, max) {
  const { year, week } = isoYearWeek(new Date());
  return pickInRange(`${seedStr}|w|${year}-${week}`, min, max);
}

/**
 * Compteur mensuel (change le 1er du mois à 5h du matin).
 * @param {string} seedStr   identifiant unique du compteur (ex: 'couples-compatibilite')
 * @param {number} min       valeur minimale possible
 * @param {number} max       valeur maximale possible (inclusive)
 */
export function monthlyCounter(seedStr, min, max) {
  // On décale l'heure courante de -5h pour que le passage de mois ait lieu
  // à 5h du matin (et pas à minuit).
  const now = new Date();
  const shifted = new Date(now.getTime() - 5 * 60 * 60 * 1000);
  const bucket = `${shifted.getFullYear()}-${shifted.getMonth() + 1}`;
  return pickInRange(`${seedStr}|m|${bucket}`, min, max);
}

/**
 * Compteur quotidien (change tous les jours à minuit).
 */
export function dailyCounter(seedStr, min, max) {
  const d = new Date();
  const bucket = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  return pickInRange(`${seedStr}|d|${bucket}`, min, max);
}
